<div dynamicGrid [tableContainerElement]="tableContainer" [selector]="selector" fxLayout="column" fxLayoutGap="10px">
  <h2 class="page-header left">
    Mantenimiento de Solicitante
  </h2>
  <div fxLayout="row" fxLayout.lt-md="column" class="right" *ngIf="canCreateUpdate">
    <button mat-icon-button color="primary" class="button1" (click)="addRow()">
      <mat-icon>add_circle</mat-icon>
    </button>
    <button mat-icon-button color="primary" class="button1" (click)="saveRows()" [disabled]="disableSaveButton">
      <mat-icon>save</mat-icon>
    </button>
  </div>
  <fab-loading-spinner *ngIf="isLoading"></fab-loading-spinner>
  <div #tableContainer class="table-height">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort>
      <!-- id Column -->
      <ng-container matColumnDef="idSolicitante">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header> ID
          <rem-string-filter #tableFilter columnDef="idSolicitante" (filterChange)="filterChange($event);"
                             [operators]="operators"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-lgtext">
          <span *ngIf="!element.editing">{{ element.idSolicitante }}</span>
          <mat-form-field #idSolicitanteField appearance="fill" *ngIf="element.editing" class="cell-width-lgtext">
            <input autocomplete="off" matInput [(ngModel)]="element.idSolicitante" required minlength="1" maxlength="9" pattern="^\d+$"
            (change)="checkId(element, idSolicitanteField)">
            <mat-icon matPrefix *ngIf="element.idSolicitante !== element.originalSolicitante.idSolicitante && !element.add"
                      color="warn" class="dirty-indicator">info
            </mat-icon>
          </mat-form-field>
        </td>
      </ng-container>
      <!-- Solicitante Column -->
      <ng-container matColumnDef="solicitante">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header> Solicitante
          <rem-string-filter #tableFilter columnDef="solicitante" (filterChange)="filterChange($event);"
                             [operators]="operators"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-xltext">
          <span *ngIf="!element.editing"> {{element.solicitante}} </span>
          <mat-form-field appearance="fill" *ngIf="element.editing" class="cell-width-xltext">
            <input autocomplete="off" matInput [(ngModel)]="element.solicitante" required minlength="1" maxlength="50" pattern=".+, .+">
            <mat-icon matPrefix *ngIf="element.solicitante !== element.originalSolicitante.solicitante && !element.add"
                      color="warn" class="dirty-indicator">info
            </mat-icon>
          </mat-form-field>
        </td>
      </ng-container>
      <!-- telefono Column -->
      <ng-container matColumnDef="telefono">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header> Telefono
          <rem-string-filter #tableFilter columnDef="telefono" (filterChange)="filterChange($event);"
                             [operators]="operators"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-xltext">
          <span *ngIf="!element.editing"> {{element.telefono}} </span>
          <mat-form-field appearance="fill" *ngIf="element.editing" class="cell-width-xltext">
            <input autocomplete="off" matInput [(ngModel)]="element.telefono" maxlength="16" pattern="^\d*$">
            <mat-icon matPrefix *ngIf="element.telefono !== element.originalSolicitante.telefono && !element.add"
                      color="warn" class="dirty-indicator">info
            </mat-icon>
          </mat-form-field>
        </td>
      </ng-container>
      <!-- mail Column -->
      <ng-container matColumnDef="mail">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header> Mail
          <rem-string-filter #tableFilter columnDef="mail" (filterChange)="filterChange($event);"
                             [operators]="operators"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-xltext">
          <span *ngIf="!element.editing"> {{element.mail}} </span>
          <mat-form-field appearance="fill" *ngIf="element.editing" class="cell-width-xltext">
            <input autocomplete="off" matInput [(ngModel)]="element.mail" maxlength="50">
            <mat-icon matPrefix *ngIf="element.mail !== element.originalSolicitante.mail && !element.add"
                      color="warn" class="dirty-indicator">info
            </mat-icon>
          </mat-form-field>
        </td>
      </ng-container>
      <!-- Almacen Column -->
      <ng-container matColumnDef="almacen">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header>Almacen
          <rem-string-filter #tableFilter columnDef="almacenField" (filterChange)="filterChange($event);"
                             [operators]="operators"></rem-string-filter></th>
        <td mat-cell *matCellDef="let element" class="cell-width-xltext">
          <div *ngIf="!element.editing; else almacenBox">
            {{ element.almacenField }}
          </div>
          <ng-template #almacenBox>
            <mat-form-field appearance="fill" class="cell-width-xltext">
              <input matInput [(ngModel)]="element.almacenField" [matAutocomplete]="autoAlmacen"
                     (ngModelChange)="changeAlmacen(element)"
                     required [appFunctionValidator]="validateAlmacenSelection(almacenesMap)">
              <mat-autocomplete #autoAlmacen="matAutocomplete">
                <mat-option *ngFor="let choice of filteredAlmacenes(element)" [value]="choice">
                  {{ choice }}
                </mat-option>
              </mat-autocomplete>
              <mat-icon matPrefix *ngIf="element.almacen.codAlmacen !== element.originalSolicitante.almacen.codAlmacen && !element.add"
                        color="warn" class="dirty-indicator">info
              </mat-icon>
            </mat-form-field>
          </ng-template>
        </td>
      </ng-container>
      <!-- Dock Column -->
      <ng-container matColumnDef="dock">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header>Cód Dock
          <rem-string-filter #tableFilter columnDef="dockCode" (filterChange)="filterChange($event);"
                             [operators]="operators"></rem-string-filter></th>
        <td mat-cell *matCellDef="let element" class="cell-width-xltext">
          <div>
            {{ element.almacen.dock?.dock }}
          </div>
        </td>
      </ng-container>
      <!-- Dock Inactive Column -->
      <ng-container matColumnDef="dockInactive">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header>Dock Inactive</th>
        <td mat-cell *matCellDef="let element" class="cell-width-smtext">
          <div id="inactive-dock-indicator">
            <mat-icon color="warn" *ngIf="!element.almacen.dock.estado && element.almacen.dock.dock?.length > 0" matTooltip="Dock no está activo.">info</mat-icon>
          </div>
        </td>
      </ng-container>
      <!-- duns_dock Column -->
      <ng-container matColumnDef="dunsDock">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header>Duns Dock
          <rem-string-filter #tableFilter columnDef="dunsDock" (filterChange)="filterChange($event);"
                             [operators]="operators"></rem-string-filter></th>
        <td mat-cell *matCellDef="let element" class="cell-width-xltext">
          <div>
            {{ element.almacen.dock?.dunsDock }}
          </div>
        </td>
      </ng-container>
      <!-- ptoEmision Column -->
      <ng-container matColumnDef="ptoEmision">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header> PTO Emision
          <rem-string-filter #tableFilter columnDef="ptoEmision" (filterChange)="filterChange($event);"
                             [operators]="operators"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-mtext">
          <span *ngIf="!element.editing; else ptoEmisionBox"> {{element.ptoEmision}} </span>
          <ng-template #ptoEmisionBox>
            <mat-form-field appearance="fill" class="cell-width-mtext">
              <mat-select [(ngModel)]="element.ptoEmision" name="ptoEmision" required disableOptionCentering>
                <mat-option *ngFor="let ptoEmision of ptoEmisions" [value]="ptoEmision.code">{{ ptoEmision.code }}</mat-option>
              </mat-select>
              <mat-icon matPrefix *ngIf="isDirtyAndNotAdd(element, 'ptoEmision')"
                        color="warn" class="dirty-indicator">info
              </mat-icon>
            </mat-form-field>
          </ng-template>
        </td>
      </ng-container>
      <!-- Balanza Column -->
      <ng-container matColumnDef="balanza">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header>Balanza
          <rem-string-filter #tableFilter columnDef="balanza"
                             (filterChange)="filterChange($event);"></rem-string-filter></th>
        <td mat-cell *matCellDef="let element" class="cell-width-smtext">
          <div *ngIf="!element.editing; else balanzaBox">
            {{ element.balanza }}
          </div>
          <ng-template #balanzaBox>
            <mat-form-field appearance="fill" class="cell-width-smtext">
              <mat-select [(ngModel)]="element.balanza" name="balanza" required>
                <mat-option *ngFor="let choice of balanzaChoices" [value]="choice">
                  {{ choice }}
                </mat-option>
              </mat-select>
              <mat-icon matPrefix *ngIf="element.balanza !== element.originalSolicitante.balanza && !element.add"
                        color="warn" class="dirty-indicator">info
              </mat-icon>
            </mat-form-field>
          </ng-template>
        </td>
      </ng-container>
      <!-- otros datos Column -->
      <ng-container matColumnDef="otrosDatos">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Otros Datos
          <rem-string-filter #tableFilter columnDef="otrosDatos"
                             (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element">
          <div class="cell-width-med-decription breakwrap" *ngIf="!element.editing; else otrosDatosBox">
            {{element.otrosDatos}}
          </div>
          <ng-template #otrosDatosBox>
            <mat-form-field class="cell-width-med-decription" appearance="fill">
              <textarea autocomplete="off" matInput maxlength=250 [(ngModel)]="element.otrosDatos" required></textarea>
              <mat-icon matPrefix *ngIf="isDirtyAndNotAdd(element, 'otrosDatos')"
                        color="warn" class="dirty-indicator">info
              </mat-icon>
            </mat-form-field>
          </ng-template>
        </td>
      </ng-container>
      <!-- estado Column -->
      <ng-container matColumnDef="estado">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header>Estado
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-mtext">
          <div *ngIf="!element.editing || element.add; else estadoBox">
            <span *ngIf="element.estado">Active</span>
            <span *ngIf="!element.estado">Inactive</span>
          </div>
          <ng-template #estadoBox>
            <mat-form-field appearance="fill" class="cell-width-mtext">
              <mat-select [(ngModel)]="element.estado" name="estado" required>
                <mat-option [value]=true>
                  Active
                </mat-option>
                <mat-option [value]=false>
                  Inactive
                </mat-option>
              </mat-select>
              <mat-icon matPrefix *ngIf="element.estado !== element.originalSolicitante.estado && !element.add"
                        color="warn" class="dirty-indicator">info
              </mat-icon>
            </mat-form-field>
          </ng-template>
        </td>
      </ng-container>
      <!-- usrCreacion Column -->
      <ng-container matColumnDef="usrCreacion">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header>Usu<br>Creación
          <rem-string-filter #tableFilter columnDef="usrCreacion"
                             (filterChange)="filterChange($event);"></rem-string-filter></th>
        <td mat-cell *matCellDef="let element" class="cell-width-smtext">
          {{element.usrCreacion}}
        </td>
      </ng-container>
      <!-- fecCreacion Column -->
      <ng-container matColumnDef="fecCreacion">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header> Fec<br>Creación
          <rem-date-filter #tableFilter columnDef="fecCreacion" [operators]="dateOperators"
                           (filterChange)="filterChange($event);"></rem-date-filter></th>
        <td mat-cell *matCellDef="let element" class="cell-width-smtext">
          {{element.fecCreacion | customDate}}
        </td>
      </ng-container>
      <!-- usrModif Column -->
      <ng-container matColumnDef="usrModif">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header> Usu<br>Modificación
          <rem-string-filter #tableFilter columnDef="usrModif"
                             (filterChange)="filterChange($event);"></rem-string-filter></th>
        <td mat-cell *matCellDef="let element" class="cell-width-smtext">
          {{element.usrModif ?? ""}}
        </td>
      </ng-container>
      <!-- fecModif Column -->
      <ng-container matColumnDef="fecModif">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header> Fec<br>Modificación
          <rem-date-filter #tableFilter columnDef="fecModif" [operators]="dateOperators"
                         (filterChange)="filterChange($event);"></rem-date-filter></th>
        <td mat-cell *matCellDef="let element" class="cell-width-smtext">
          {{element.fecModif | customDate}}
        </td>
      </ng-container>
      <!-- Edited Indicator -->
      <ng-container matColumnDef="edited">
        <th mat-header-cell *matHeaderCellDef scope="col"></th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button *ngIf="element.editing && canCreateUpdate" (click)="revertRow(element)">
            <mat-icon color="tertiary">cancel</mat-icon>
          </button>
          <button mat-icon-button *ngIf="!element.editing && canCreateUpdate" (click)="edit(element)">
            <mat-icon color="secondary">create</mat-icon>
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  <mat-paginator [pageSize]="defaultPageSize"
                 [pageSizeOptions]="pageSizeOptions"></mat-paginator>
</div>
